import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { WizardSteps } from './WizardSteps';

export const Steps = () => {
  const stepper = useSelector((state: RootState) => state.stepper);

  return <WizardSteps steps={stepper.steps} />;
};
